import $ from '../$';
import './clone';
import './get';
import './map';
import './replaceWith';
$.fn.replaceAll = function (target) {
    return $(target).map((index, element) => {
        $(element).replaceWith(index ? this.clone() : this);
        return this.get();
    });
};
